import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Sidebar from "components/sidebar";
import Footer from "components/footer/Footer";
import routes from "routes.js";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

// const getActiveRoute = (routes) => {
//   let currentPath = window.location.pathname;
//   for (let i = 0; i < routes.length; i++) {
//     const fullPath = routes[i].layout + "/" + routes[i].path;

//     if (currentPath.includes(fullPath)) {
//       if (routes[i].name && routes[i].name !== "") {
//         setCurrentRoute(routes[i].name);
//       } else if (routes[i].parent) {
//         // Find parent route to set its name
//         const parentRoute = routes.find(r => r.path === routes[i].parent);
//         if (parentRoute && parentRoute.name) {
//           setCurrentRoute(parentRoute.name);
//         }
//       }
//       return;
//     }
//   }

//   setCurrentRoute("Main Dashboard");
// };

const getActiveRoute = (routes) => {
  const currentPath = window.location.pathname;

  for (let i = 0; i < routes.length; i++) {
    const fullPath = `${routes[i].layout}/${routes[i].path}`;
    const fullPattern = fullPath.replace(/:[^/]+/g, "[^/]+"); // Replace :id with pattern
    const fullRegex = new RegExp(`^${fullPattern}$`);

    // Direct match with fullPath
    if (fullRegex.test(currentPath)) {
      setCurrentRoute(routes[i].name || "Main Dashboard");
      return;
    }

    // Check aliases (also support dynamic :id)
    if (routes[i].aliases) {
      for (let alias of routes[i].aliases) {
        const aliasPattern = alias.replace(/:[^/]+/g, "[^/]+");
        const aliasRegex = new RegExp(`^${aliasPattern}$`);

        if (aliasRegex.test(currentPath)) {
          // Prefer route name, else parent route name
          if (routes[i].name) {
            setCurrentRoute(routes[i].name);
          } else if (routes[i].parent) {
            const parentRoute = routes.find(r => r.path === routes[i].parent);
            setCurrentRoute(parentRoute?.name || "Main Dashboard");
          } else {
            setCurrentRoute("Main Dashboard");
          }
          return;
        }
      }
    }
  }

  setCurrentRoute("Main Dashboard");
};


  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        return (
          <Route path={`/${prop.path}`} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              secondary={getActiveNavbar(routes)}
              {...rest}
            />
            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
              <Routes>
                {getRoutes(routes)}

                <Route
                  path="/"
                  element={<Navigate to="/admin/default" replace />}
                />
              </Routes>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
